import React, { useState, useEffect, useCallback } from 'react'
import { Form, Modal, Input, Space,   Radio, Steps, App, Select, InputNumber } from 'antd'
import Icon from '../../../cpn/Icon'
import { useSKspjdAddMutation } from '../../../store/DianShangYeWuApi'
function RuleIncomeAdd(props) {
    const deptList = props.deptList.map(item => ({value:item.d_id,label:item.d_name,key:item.d_id}));
    const useList = props.useList.map(item => ({value:item.yh_id,label:item.yh_name,key:item.yh_id}));
    const [newNode, setNewNode] = useState([]);
    const {message} = App.useApp();
    const [items, setItems] = useState([]);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [submitAdd] = useSKspjdAddMutation();
    const [editNodeModalOpen, setEditNodeModalOpen] = useState(false);
    const [editingNodeIndex, setEditingNodeIndex] = useState(-1);
    const [editNodeForm] = Form.useForm();
    const [editNodeInfo, setEditNodeInfo] = useState({
        node_type: '',
        node_user_id: '',
        node_user_name: '',
    });
    const [info, setInfo] = useState({
        'ddsr_spjd_qy_id': props.qy_id,
        'ddsr_spjd_qy_name': props.qy_name,
        'ddsr_spjd_xuhao': '',
        'ddsr_spjd_name': '',
        'ddsr_spjd_yh_id': '',
        'ddsr_spjd_yh_name': '',
        'ddsr_spjd_uid': props.yh_id,
        'ddsr_spjd_uname': props.yh_name,
        'ddsr_spjd_content': '',
        'ddsr_spjd_user_id': '',
        'ddsr_spjd_user_name': '',
        'ddsr_spjd_bm_id': '',
        'ddsr_spjd_bm_name': '',
        'ddsr_spjd_zflx': '',
        'ddsr_spjd_amount_min': '',
        'ddsr_spjd_amount_max': '',
    })
    const handleEditNode = useCallback((index) => {
        const node = newNode[index];
        setEditingNodeIndex(index);
        const nodeInfo = {
            node_type: node.ddsr_spjd_name,
            node_user_id: node.ddsr_spjd_yh_id,
            node_user_name: node.ddsr_spjd_yh_name,
        };
        setEditNodeInfo(nodeInfo);
        setEditNodeModalOpen(true);
        // 延迟设置表单值，确保 Modal 已经打开
        setTimeout(() => {
            editNodeForm.setFieldsValue({
                node_type: node.ddsr_spjd_name,
                node_user_id: node.ddsr_spjd_yh_id,
            });
        }, 100);
    }, [newNode, editNodeForm]);
    
    const handleDeleteNode = useCallback((index) => {
        setNewNode(prev => prev.filter((_, i) => i !== index));
    }, []);
    
    useEffect(() => {
        setItems(
            newNode.map((node, index) => ({
                ...node,
                subTitle: (
                    <Space>
                        <a onClick={() => handleEditNode(index)}>修改</a>
                        <a onClick={() => handleDeleteNode(index)} style={{color: 'red'}}>删除</a>
                    </Space>
                )
            }))
        );
    }, [newNode, handleEditNode, handleDeleteNode]);
    
    const handleSaveEditNode = () => {
        if(!editNodeInfo.node_type){
            message.error('请选择节点类型');
            return;
        }
        if(!editNodeInfo.node_user_name){
            message.error('请选择操作员');
            return;
        }
        
        setNewNode(prev => prev.map((node, index) => 
            index === editingNodeIndex 
                ? {
                    title: editNodeInfo.node_type + '：' + editNodeInfo.node_user_name,
                    content: '',
                    status: 'wait',
                    ddsr_spjd_name: editNodeInfo.node_type,
                    ddsr_spjd_yh_id: editNodeInfo.node_user_id,
                    ddsr_spjd_yh_name: editNodeInfo.node_user_name,
                }
                : node
        ));
        setEditNodeModalOpen(false);
        setEditingNodeIndex(-1);
        editNodeForm.resetFields();
        setEditNodeInfo({
            node_type: '',
            node_user_id: '',
            node_user_name: '',
        });
    };
    const onAdd = () => {
        if(!info.ddsr_spjd_content){
            message.error('请输入规则名称');
            return;
        }
        if(!info.ddsr_spjd_bm_id){
            message.error('请选择部门');
            return;
        }
        if(!info.ddsr_spjd_zflx){
            message.error('请选择往来类型');
            return;
        }
        if(!info.ddsr_spjd_amount_min){
            message.error('请输入最小金额');
            return;
        }
        if(!info.ddsr_spjd_amount_max){
            message.error('请输入最大金额');
            return;
        }
        
        let obj ={
            'ddsr_spjd_qy_id': props.qy_id,
            'ddsr_spjd_qy_name': props.qy_name,
            'ddsr_spjd_xuhao': '',
            'ddsr_spjd_name': '',
            'ddsr_spjd_yh_id': '',
            'ddsr_spjd_yh_name': '',
            'ddsr_spjd_uid': props.yh_id,
            'ddsr_spjd_uname': props.yh_name,
            'ddsr_spjd_content': info.ddsr_spjd_content,
            'ddsr_spjd_user_id': info.ddsr_spjd_user_id,
            'ddsr_spjd_user_name': info.ddsr_spjd_user_name,
            'ddsr_spjd_zflx': info.ddsr_spjd_zflx,
            'ddsr_spjd_amount_min': info.ddsr_spjd_amount_min,
            'ddsr_spjd_amount_max': info.ddsr_spjd_amount_max,
            'ddsr_spjd_bm_id': info.ddsr_spjd_bm_id,
            'ddsr_spjd_bm_name': info.ddsr_spjd_bm_name,
        }
        
        // 2. 校验 items 节点
        if (!items || items.length === 0 || (items.length === 1 && !items[0].ddsr_spjd_yh_id)) {
            message.error("请设置至少一个审批/抄送节点");
            return;
        }
        // 3. 过滤掉无效节点
        const validItems = items.filter(item => !!item.ddsr_spjd_yh_id && !!item.ddsr_spjd_yh_name);

        // 4. 填充 obj 字段
        // 不需要前面1,2两个元素了，直接从items的第一个开始
        // 填充序号
        let s = validItems.length;
        let xuhaoArr = [];
        for(let i=1; i<=s; ++i) xuhaoArr.push(i);
        obj.ddsr_spjd_xuhao = xuhaoArr.join(',');

        // 填充ddsr_spjd_name
        obj.ddsr_spjd_name = validItems.map(item => item.ddsr_spjd_name).join(',');

        // 填充ddsr_spjd_yh_id
        obj.ddsr_spjd_yh_id = validItems.map(item => item.ddsr_spjd_yh_id).join(',');

        // 填充ddsr_spjd_yh_name
        obj.ddsr_spjd_yh_name = validItems.map(item => item.ddsr_spjd_yh_name).join(',');

       

        // 5. 提交
        submitAdd(obj).then(res => {
            if (res && res.data && res.data.Status === 'success') {
                message.success('新增成功');
                setOpen(false);
                setNewNode([]);
                setItems([]);
                setInfo({...info, 'ddsr_spjd_user_id':'', 'ddsr_spjd_user_name':''});
                props.onSuccess && props.onSuccess();
            } else {
                message.error('新增失败：' + (res?.data?.Message || '未知错误'));
            }
        });
    }
    return (
        <>
            <Icon type='add' onClick={() => {
                setOpen(true)
                form.resetFields();
                setInfo({ 'ddsr_spjd_qy_id': props.qy_id,
                    'ddsr_spjd_qy_name': props.qy_name,
                    'ddsr_spjd_xuhao': '',
                    'ddsr_spjd_name': '',
                    'ddsr_spjd_yh_id': '',
                    'ddsr_spjd_yh_name': '',
                    'ddsr_spjd_uid': props.yh_id,
                    'ddsr_spjd_uname': props.yh_name,
                    'ddsr_spjd_content': '',
                    'ddsr_spjd_user_id': '',
                    'ddsr_spjd_user_name': '',
                    'ddsr_spjd_bm_id': '',
                    'ddsr_spjd_bm_name': '',
                    'ddsr_spjd_zflx': '',
                    'ddsr_spjd_amount_min': '',
                    'ddsr_spjd_amount_max': '',});
                
                setNewNode([]);
                setItems([]);
                setEditNodeModalOpen(false);
                setEditingNodeIndex(-1);
                editNodeForm.resetFields();
                setEditNodeInfo({
                    node_type: '',
                    node_user_id: '',
                    node_user_name: '',
                });
            }} />
            <Modal
                title='新增收款单审批规则'
                open={open}
                onCancel={() => {
                    setOpen(false)
                    form.resetFields();
                    setInfo({...info, 'ddsr_spjd_user_id':'', 'ddsr_spjd_user_name':''});
                    setNewNode([]);
                    setItems([]);
                    setEditNodeModalOpen(false);
                    setEditingNodeIndex(-1);
                    editNodeForm.resetFields();
                    setEditNodeInfo({
                        node_type: '',
                        node_user_id: '',
                        node_user_name: '',
                    });
                }}
                width={800}
                onOk={() => {
                    form.validateFields().then(() => {
                        onAdd();
                    }).catch((err) => {
                        // 表单验证失败，不执行提交
                    });
                }}
            >
                <Form form={form} layout='horizontal' labelCol={{ span: 6 }} name='ruleIncomeAddForm'>
                    <Form.Item label='收款单规则名称' name='rule_name' rules={[{ required: true, message: '请输入规则名称' }]}>
                        <Input onChange={(e) => {setInfo(prev=>({...prev, 'ddsr_spjd_content': e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item label='收款单部门' name='dept' wrapperCol={{ span: 10 }} required >
                        <Select options={deptList} onChange={(e,f) => {setInfo(prev=>({...prev, 'ddsr_spjd_bm_id':e, 'ddsr_spjd_bm_name':f.label}))}} />
                    </Form.Item>
                    <Form.Item label='收款单往来类型' name='ddsr_spjd_zflx' wrapperCol={{ span: 10 }} required >
                        <Radio.Group options={[
                            {value: '现收', label: '现收'},
                                {value: '应收', label: '应收'},
                                {value: '核销应收', label: '核销应收'},
                            ]} onChange={(e,f) => {setInfo(prev=>({...prev, 'ddsr_spjd_zflx':e.target.value}))}} >
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label='收款单最小金额' name='ddsr_spjd_amount_min' wrapperCol={{ span: 10 }} required >
                         <InputNumber min={0.01} precision={2} max={99999999.99} onChange={(value) => {setInfo(prev=>({...prev, 'ddsr_spjd_amount_min': value}))}} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item label='收款单最大金额' name='ddsr_spjd_amount_max' wrapperCol={{ span: 10 }} required >
                        <InputNumber min={0.01} precision={2} max={99999999.99} onChange={(value) => {setInfo(prev=>({...prev, 'ddsr_spjd_amount_max': value}))}} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item label="审批点" required wrapperCol={{ span: 18 }}>
                        <Space size={10}>
                            <Form.Item  name="node_type" noStyle>
                                <Radio.Group
                                    onChange={(e) => {
                                        setInfo(prev=>({...prev, node_type: e.target.value}))
                                    }}
                                >
                                    <Radio value="审批">审批</Radio>
                                    <Radio value="抄送">抄送</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item name="node_user_id" noStyle>
                                <Select options={useList} onChange={(e,f) => {setInfo(prev=>({...prev, 'node_user_id':e, 'node_user_name':f.label}))}} style={{ width: '200px' }} placeholder={info.node_type === '审批' ? '请选择审批人' : '请选择抄送人'} disabled={info.node_type === ''} />
                            </Form.Item>
                            <Icon 
                                type='add' 
                                onClick={() => {
                                if(!info.node_type){
                                    message.error('请选择节点类型')
                                    return;
                                }
                                if(!info.node_user_name){
                                    message.error('请选择操作员')
                                    return;
                                }
                                setNewNode(prev => [...prev, {
                                    title: info.node_type + '：' + info.node_user_name,
                                    content: '',
                                    status: 'wait',
                                    ddsr_spjd_name: info.node_type,
                                    ddsr_spjd_yh_id: info.node_user_id,
                                    ddsr_spjd_yh_name: info.node_user_name,
                                }]);
                                form.resetFields(['node_type', 'node_user_id', 'node_content']);
                                setInfo(prev => ({
                                    ...prev,
                                    node_type: '',
                                    node_user_name: '',
                                    node_content: '',
                                    node_user_id: '',
                                }));
                                }} title='添加审批节点' 
                            />
                        </Space>
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 18,offset: 6 }}>
                        {items.length===0 && ''}
                        <div>
                                <style>
                                    {`
                                        .ant-steps-item-title {
                                            color: #000 !important;
                                        }
                                    `}
                                </style>
                                <Steps
                                    items={items}
                                    orientation="vertical"  
                                    size="small"
                                    current={items.length-1}
                                />
                            </div>
                    </Form.Item>  
                </Form>
            </Modal>
            <Modal
                title='修改审批点'
                open={editNodeModalOpen}
                onOk={handleSaveEditNode}
                onCancel={() => {
                    setEditNodeModalOpen(false);
                    setEditingNodeIndex(-1);
                    editNodeForm.resetFields();
                    setEditNodeInfo({
                        node_type: '',
                        node_user_id: '',
                        node_user_name: '',
                    });
                }}
                width={500}
            >
                <Form form={editNodeForm} layout='vertical'>
                    <Form.Item label='节点类型' name='node_type' rules={[{ required: true, message: '请选择节点类型' }]}>
                        <Radio.Group
                            value={editNodeInfo.node_type}
                            onChange={(e) => {
                                setEditNodeInfo(prev => ({...prev, node_type: e.target.value}));
                            }}
                        >
                            <Radio value="审批">审批</Radio>
                            <Radio value="抄送">抄送</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label='操作员' name='node_user_id' rules={[{ required: true, message: '请选择操作员' }]}>
                        <Select 
                            options={useList} 
                            value={editNodeInfo.node_user_id}
                            onChange={(value, option) => {
                                setEditNodeInfo(prev => ({
                                    ...prev, 
                                    'node_user_id': value, 
                                    'node_user_name': option ? option.label : ''
                                }));
                            }} 
                            placeholder={editNodeInfo.node_type === '审批' ? '请选择审批人' : '请选择抄送人'}
                            disabled={!editNodeInfo.node_type}
                        />                        
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default RuleIncomeAdd